<script setup lang="ts">
import { type Icon } from '@/assets/icons'
import { UiTwoToneColor, UiButtonVariant } from '@afs/design-system'

import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import { useData } from 'vike-vue/useData'
import type { SimulatorPageData } from '@/pages/(subscription)/+data'
import { usePageContext } from 'vike-vue/usePageContext'

const { t } = useI18n()

const { header } = usePageContext()
const { simulator } = useData<SimulatorPageData>()

const isHelpModalOpen = ref<boolean>(false)

const headerProps = {
  legalMessage: header?.legalMessage,
  buttonLeft: {
    text: t('simulator.header.help'),
    prependIcon: 'chat' as Icon,
    onClick: () => (isHelpModalOpen.value = true),
  },
  buttonRight: {
    text: t('simulator.header.quit'),
    to: '/',
    variant: UiButtonVariant.OUTLINE,
  },
  logo: simulator.logo,
  linkLogo: simulator.linkLogo,
  partnerLogo: simulator.partnerLogo,
}
</script>

<template>
  <organisms-ui-header-lite
    v-bind="headerProps"
    class="mb-7"
  />
  <molecules-ui-modal
    v-if="simulator.popin.title"
    v-model="isHelpModalOpen"
    v-bind="{ title: simulator.popin.title }"
    :color="UiTwoToneColor.YELLOW_03"
  >
    <div class="SimulatorHeader__Modal__content color-blue-01">
      <p class="heading-2">{{ simulator.popin.subtitle }}</p>
      <molecules-ui-rich-text
        v-if="simulator.popin.content"
        :content="simulator.popin.content"
      />
      <span v-if="simulator.popin.phoneNumber">
        <p
          class="SimulatorHeader__Modal__phone mt-4 heading-2"
          :href="`tel:${simulator.popin.phoneNumber}`"
        >
          <atoms-ui-icon
            name="phone"
            class="SimulatorHeader__Modal__icon mr-2"
          />
          <span class="mt-1">
            {{ simulator.popin.phoneNumber }}
          </span>
        </p>
        <p
          v-if="simulator.popin.caption"
          class="mt-1 paragraph-4"
        >
          {{ simulator.popin.caption }}
        </p>
      </span>
      <span v-else>
        <atoms-ui-image
          v-if="simulator.popin.picture !== undefined"
          class="SimulatorHeader__Modal__image mt-5"
          v-bind="simulator.popin.picture"
        />
        <atoms-ui-button
          v-if="simulator.popin.link"
          class="mt-5"
          v-bind="simulator.popin.link"
          :variant="UiButtonVariant.TEXT"
        />
      </span>
    </div>
  </molecules-ui-modal>
</template>

<style lang="scss" scoped>
.SimulatorHeader__Modal__content {
  text-align: center;
}

.SimulatorHeader__Modal__image {
  &.Image {
    width: initial;
    margin-inline: auto;
  }
}

.SimulatorHeader__Modal__phone {
  display: inline-flex;
}

.SimulatorHeader__Modal__icon {
  font-size: 3.5rem;
}
</style>
